module.exports = __webpack_public_path__ + "static/media/Mesa-de-trabajo-21.23fb304e.jpg";